import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:42026';

/**
 * The account's interface language.
 *
 * WHY THIS IS A SEPARATE FETCH and not read off the user object:
 *
 * The portal's `user` comes from localStorage, populated by the login response,
 * and that response has never carried a locale. So `user.localePreference` was
 * always undefined, `activateLocale` always fell to en-US, and the portal
 * rendered English for an account whose stored preference was es-CO. That is
 * exactly the reported symptom: the desktop app in Spanish, the portal in
 * English, same account.
 *
 * Widening the login payload would work only for NEW sessions; every already
 * signed-in browser would keep its stale cached user. Reading the account's own
 * endpoint fixes both, and it is the same endpoint the desktop reconciles
 * against, so there is one authority for the answer rather than two.
 *
 * FAIL DIRECTION: any failure returns null and the caller keeps en-US. The
 * source locale always renders, so a locale lookup must never block the UI.
 */
export async function fetchAccountLocale(): Promise<string | null> {
  try {
    const token = localStorage.getItem('privacypal_token');
    if (!token) return null;
    const res = await axios.get(`${API_BASE_URL}/api/user/locale`, {
      headers: { 'x-access-token': token, 'x-client-id': 'privacypal-user-portal' },
      timeout: 8000,
    });
    const pref = res?.data?.data?.localePreference;
    return typeof pref === 'string' && pref ? pref : null;
  } catch {
    return null;
  }
}

export default { fetchAccountLocale };
